/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CourseInput = {
    slug: string;
    title: string;
    summary?: string;
    coverUrl?: string;
    priceCents?: number | null;
    currency?: string;
    authorName?: string;
    tags?: Array<string>;
    defaultLanguage?: string;
    visibility?: CourseInput.visibility;
    theme?: string;
};
export namespace CourseInput {
    export enum visibility {
        PUBLIC = 'public',
        PRIVATE = 'private',
    }
}

